module.exports = __webpack_public_path__ + "img/06王春明.1becd3a3.png";